import RequiredLabel from './RequiredLabel';

export default RequiredLabel;


// WEBPACK FOOTER //
// ./src/components/RequiredLabel/index.js